import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-item-two',
  templateUrl: './menu-item-two.component.html',
  styleUrls: ['./menu-item-two.component.css']
})
export class MenuItemTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
